import script from "./TokenPools.vue?vue&type=script&lang=ts&setup=true"
export * from "./TokenPools.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__